import {combineLatestWith} from 'rxjs';
import {filter, map, startWith} from 'rxjs/operators';
import {SERVICES} from '@/const/services';
import {envUtil} from '@/helper/env';
import {mockUtil} from '@/helper/moc';
import {ty} from '@/da/tingyun';
import {contracts$} from '@/streams/config/contract';
import {tvSymbol$} from '@/modules/contract/components/trading-view/streams';
import {WebWorkerSubject} from '@/observable/WebWorkerSubject';
import type {ToUiMsg, FromUiMsg, UTingYun} from '@px/ws-data';

export const wwData$ = new WebWorkerSubject<ToUiMsg, FromUiMsg>();

// 接收 worker 中的听云事件
wwData$.pipe(filter((o: ToUiMsg) => o.type === 'tingyun-event')).subscribe((o: UTingYun) => ty.createEvent(o.data));

wwData$.pipe(filter((o) => o.type === 'worker-ready')).subscribe(() => wwData$.send({type: 'ws-url', url: SERVICES.WS}));

// 根据在index/mark图表上选择的交易对匹配交易对信息；不能写死，新旧合约倍数不一样，会导致从ws-data出来的数据倍数处理有误
contracts$
  .pipe(
    filter(() => !envUtil.isBot),
    combineLatestWith(tvSymbol$.pipe(startWith(null))),
    map(([contracts, tvSymbol]) => {
      const contract = contracts.find(({markSymbol, indexSymbol}) => [markSymbol, indexSymbol].includes(tvSymbol));
      return contract?.symbol;
    })
  )
  .subscribe((symbol) => {
    wwData$.pipe(filter((o) => o.type === 'worker-ready')).subscribe(() => {
      wwData$.send({type: 'state-symbol', tradeType: 'Perpetual', symbol: mockUtil.isMock() ? 'BTCMUSDT' : symbol ?? 'EOSUSD'} as FromUiMsg);
    });
  });
